<template>
  <img :src="`${useAsset('img/logo_bg_white.svg')}`" alt="PayJoy Logo" />
</template>

<script lang="ts">
import { defineComponent } from "@vue/runtime-core";
import useAsset from "@/apps/credit-line/helpers/useAsset";

export default defineComponent({
  name: "Logo",
  props: {
    routeName: {
      default: "Home",
      type: String,
    },
  },
  setup() {
    return {
      useAsset,
    };
  },
});
</script>
<style lang="scss" scoped>
@import "@/assets/scss/_constants.scss";

img {
  max-width: 150px;
  max-height: 25px;
  @media screen and (max-width: $mobile) {
    max-width: 150px;
    max-height: 25px;
  }
}
.navbar-toggler-icon {
  @media screen and (max-width: $mobile) {
    width: 25px;
  }
}
</style>
